import {useCallback, useState} from 'react';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {tanzaniteWebText} from '~libSass/base/_exports.sass';
import './Tooltip.sass';

export const Tooltip = ({id, text, dataQaIdExitBtn}) => {
  const tooltip = window.localStorage.getItem(`show_tooltip_${id}`) ?? true;

  const [show, setShow] = useState(JSON.parse(tooltip));

  const onClose = useCallback(() => {
    setShow(false);
    window.localStorage.setItem(`show_tooltip_${id}`, false);
  }, []);

  if (!show) return null;
  return (
    <div className="fabric-card-tooltip">
      <Typography variant="paragraph2" style={{color: tanzaniteWebText}} data-qa-id={`${id}_text`}>
        {text}
      </Typography>
      <button
        className="unstyled-button"
        data-qa-id={dataQaIdExitBtn || `${id}_btn`}
        onClick={onClose}
      >
        <CloseLineIcon color={tanzaniteWebText} ratio={0.5} />
      </button>
    </div>
  );
};
